import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n.use(LanguageDetector).init({
    // we init with resources
    resources: {
        en: {
            Login: {
                loginText: 'to start', //pour commencer
                languages: 'languages', //langues
                targetApplication: 'Target Application',
                applicationName: 'Console',
                forgetPassword: 'Forget password ?', //Mot de passe oublié ?
                signIn: 'Login', //S’identifier
                requestResetPassword: 'Password reset',
                resetPassword: 'Reset your password',
                reqBtn: 'Send',
                resetBtn: 'Reset',
                password: 'Password',
                passwordConfirmation: 'Confirm Password',
                username: 'Username',
                email: 'E-mail',
            },

            Error: {
                sorry: 'Oh, Sorry',
                text: 'Something bad happened during the load of this page',
                redirect: 'You will be redirected to login page',
                seconds: 'Seconds',
            },

            Validations: {
                tooShort: 'Too short!',
                tooLong: 'Too long!',
                required: 'Required',
                invalidEmail: 'Invalid email',
                passwordLength:
                    'The length of the password must be 8 characters or more!',
                passwordMatch: 'Passwords must match',
                min60Seconds: 'Minimum must be 60 seconds or more!',
                max600Seconds: 'Maximum must be less than 600 seconds',
                endDateLessThanStartDate:
                    'End date cannot be less than Start date',
            },
            Footer: {
                operatedBy: 'Operated By',
                serverName: 'Server name',
                connected: 'Connected since',
                version: 'Version',
            },
        },
        fr: {
            Login: {
                loginText: 'pour commencer',
                applicationName: 'Console',
                targetApplication: 'Application cible',
                forgetPassword: 'Mot de passe oublié ?',
                signIn: "S'identifier",
                resetPassword: 'Réinitialiser votre mot de passe',
                resetBtn: 'Réinitialiser',
                password: 'Mot de passe',
                passwordConfirmation: 'Confirmer le mot de passe',
                username: "Nom d'utilisateur",
                email: 'Adresse électronique',
                requestResetPassword: 'Réinitialiser votre mot de passe',
                reqBtn: 'Envoyer',
                errorChangePassword:
                    'Désolé, Une erreur est survenue lors du traitement de votre requête',
                successChangePassword:
                    'Votre mot de passe à été changé avec succès',

                errorReqChangePassword:
                    'Désolé, Une erreur est survenue lors du traitement de votre requête',
                successReqChangePassword:
                    'Une demande de réinitialisation de votre mot de passe a été envoyée à votre adresse email que vous nous avez communiqué. ',
            },
            Error: {
                sorry: 'Oh, Désolé',
                text:
                    'Quelque chose s’est mal passé lors du chargement de cette page.',
                redirect: 'Vous serez redirigé vers la page de connexion',
                seconds: 'Secondes',
            },
            Validations: {
                tooShort: 'Trop court!',
                tooLong: 'Trop long!',
                required: 'Requis',
                invalidEmail: 'Email invalide',
                passwordLength:
                    'La longueur du mot de passe doit être de 8 caractères ou plus!',
                passwordMatch: 'Les mots de passe doivent correspondre',
                min60Seconds: 'Minimum doit être de 60 secondes ou plus!',
                max600Seconds: 'Maximum doit être inférieur à 600 secondes',
                endDateLessThanStartDate:
                    'La date de fin ne peut pas être inférieure à la date de début',
            },
            Footer: {
                operatedBy: 'Opéré par',
                serverName: 'Nom du serveur',
                connected: 'Connecté depuis',
                version: 'Version',
            },
        },
        de: {
            Login: {
                loginText: 'Willkommen bei der Display-Anwendung',
                targetApplication: 'Zielanwendung',
                forgetPassword: 'Passwort vergessen?',
                signIn: 'Verbinden',
                resetPassword: 'Setzen Sie Ihr Passwort zurück',
                resetBtn: 'Rücksetzen',
                password: 'Passwort',
                username: 'Benutzername',
                email: 'E-Mail-Adresse',
                passwordConfirmation: 'Passwort bestätigen',
            },

            Error: {
                sorry: 'Oh, entschuldigung',
                text: 'Beim Laden dieser Seite ist ein Fehler aufgetreten.',
                redirect: 'Sie werden zur Anmeldeseite weitergeleitet',
                seconds: 'Sekunden',
            },
            Validations: {
                tooShort: 'Zu kurz!',
                tooLong: 'Zu lang!',
                required: 'Erforderlich',
                invalidEmail: 'Ungültige E-Mail',
                passwordLength:
                    'Das Passwort muss mindestens 8 Zeichen lang sein!',
                passwordMatch: 'Passwörter müssen übereinstimmen',
                min60Seconds: 'Minimum muss 60 Sekunden oder länger sein!',
                max600Seconds: 'Maximum muss kleiner als 600 Sekunden sein',
                endDateLessThanStartDate:
                    'Das Enddatum darf nicht unter dem Startdatum liegen',
            },

            Footer: {
                operatedBy: 'Betrieben von',
                serverName: 'Servername',
                connected: 'Verbunden seit',
                version: 'Version',
            },
        },
    },
    fallbackLng: 'en',
    debug: false,

    // have a common namespace used around the full app
    // ns: ['translations'],
    // defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ',',
    },

    react: {
        wait: true,
    },
})

export default i18n
